var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"amazon-info"},[_c('validation-component',{ref:"amazonForm",attrs:{"validation-condition":_vm.amazonCondition}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }